import { Outlet, useLocation } from 'react-router-dom'
import { Suspense } from 'react'
import { Sidebar } from './sidebar'
import { Topbar } from './topbar'
import { ImpersonationBanner } from './impersonation-banner'
import { RouteErrorBoundary } from '@/components/shared/route-error-boundary'
import { RouteFallback } from '@/components/shared/route-fallback'
import { OnboardingGate } from '@/features/onboarding/onboarding-gate'

export function AppShell() {
  const location = useLocation()
  return (
    <div className="flex h-screen overflow-hidden bg-background">
      <OnboardingGate />
      <a href="#main-content" className="skip-to-content">Skip to main content</a>
      <Sidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <ImpersonationBanner />
        <Topbar />
        <main id="main-content" className="scrollbar-thin flex-1 overflow-y-auto p-6" tabIndex={-1}>
          {/* Keying the boundary by pathname resets it on navigation
              so an error on one page doesn't stick around on the next. */}
          <RouteErrorBoundary key={location.pathname}>
            <Suspense fallback={<RouteFallback />}>
              <Outlet />
            </Suspense>
          </RouteErrorBoundary>
        </main>
      </div>
    </div>
  )
}
